/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import 'flatpickr/dist/flatpickr.css'
import axiosPlugin from './plugins/axios-plugin';
import i18n from './translations';
import Vuelidate from 'vuelidate';
import moment from 'moment';
import utils from './plugins/utils/utils';
import IdleVue from "idle-vue";
import numeral from 'numeral';

const eventsHub = new Vue();

Vue.config.productionTip = false;

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: process.env.VUE_APP_IDLE_TIME,
    startAtIdle: false
});

Vue.config.productionTip = false;
Vue.use(utils);
Vue.use(Vuelidate);
Vue.use(axiosPlugin);
Vue.use(ArgonDashboard);
Vue.prototype.numeral = numeral;
Vue.prototype.moment = moment;
new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    computed: {
        idAndSite() {
            return {
                site_id: +this.$store.state.general.user.shop_id
            }
        }
    },
    watch: {
        idAndSite:{
            handler(n) {
                this.$axios.defaults.headers['X-SWIS'] =  JSON.stringify(n);
            },
            deep: true
        }
    },
    onIdle() {

    },
    created(){
        this.$store.commit('SET_ISDEV', process.env.NODE_ENV);
        const token = JSON.parse(sessionStorage.getItem('token'));
        const site_id = JSON.parse(sessionStorage.getItem('site_id'));

        this.$axios.defaults.headers['Authorization'] = `Bearer ${token}` || 'no token';
        this.$axios.defaults.headers['X-SWIS'] = JSON.stringify({site_id: site_id})
    },
    mounted() {
        this.$store.commit('SET_PERMISSIONS', JSON.parse(sessionStorage.getItem('permissions')));
        this.$store.commit('SET_MENU', JSON.parse(sessionStorage.getItem('menu')));
        this.$store.commit('SET_USER_NAME', JSON.parse(sessionStorage.getItem('username')));
        this.$store.commit('SET_SHOPS_LIST', JSON.parse(sessionStorage.getItem('shop')));
        this.$store.commit('SET_SHOP', JSON.parse(sessionStorage.getItem('site_id')));
        this.$store.commit('SET_SHOP_NAME', sessionStorage.getItem('site_name'));

        const site_id = JSON.parse(sessionStorage.getItem('site_id'));
        this.$axios.defaults.headers['X-SWIS'] = JSON.stringify({site_id: site_id});
    }
}).$mount('#app');